interface SubPage {
  labelKey: string;
  key: string;
  checked: boolean;
}
interface Page {
  labelKey: string;
  key: string;
  subPages?: SubPage[];
  checked: boolean;
}

/**
 * Construit la structure des pages avec l'état coché en fonction des pages du message.
 */
function buildPages(messagePages: string[] = []): Page[][] {
  return [
    [
      {
        labelKey: "communications.pages.toutes",
        key: "all",
        checked: messagePages.includes("all"),
      },
    ],
    [
      {
        labelKey: "communications.pages.accueil",
        key: "home",
        checked: messagePages.includes("home"),
      },
      {
        labelKey: "communications.pages.panier",
        key: "panier",
        checked: messagePages.includes("panier"),
      },
      {
        labelKey: "communications.pages.recherche",
        key: "search",
        checked: messagePages.includes("search"),
      },
      {
        labelKey: "communications.pages.licences-commandees",
        key: "licences_actives",
        checked: messagePages.includes("licences_actives"),
      },
      {
        labelKey: "communications.pages.mon-etablissement",
        key: "etablissements_actuel",
        checked: messagePages.includes("etablissements_actuel"),
      },
      {
        labelKey: "communications.pages.mon-profil",
        key: "compte",
        checked: messagePages.includes("compte"),
      },
    ],
    [
      {
        labelKey: "communications.pages.catalogues",
        key: "catalogues_",
        checked: messagePages.includes("catalogues_"),
        subPages: [
          {
            labelKey: "communications.pages.accueil-catalogue",
            key: "catalogue_accueil",
            checked: messagePages.includes("catalogue_accueil"),
          },
          {
            labelKey: "communications.pages.detail-article",
            key: "catalogue_detail",
            checked: messagePages.includes("catalogue_detail"),
          },
        ],
      },
      {
        labelKey: "communications.pages.listes",
        key: "listes_devis_listes",
        checked: messagePages.includes("listes_devis_listes"),
        subPages: [
          {
            labelKey: "communications.pages.vos-listes",
            key: "listes_devis_listes",
            checked: messagePages.includes("listes_devis_listes"),
          },
          {
            labelKey: "communications.pages.details-liste",
            key: "listes_devis_listes_item",
            checked: messagePages.includes("listes_devis_listes_item"),
          },
        ],
      },
      {
        labelKey: "communications.pages.devis",
        key: "listes_devis_devis",
        checked: messagePages.includes("listes_devis_devis"),
        subPages: [
          {
            labelKey: "communications.pages.vos-devis",
            key: "listes_devis_devis",
            checked: messagePages.includes("listes_devis_devis"),
          },
          {
            labelKey: "communications.pages.details-devis",
            key: "listes_devis_devis_item",
            checked: messagePages.includes("listes_devis_devis_item"),
          },
        ],
      },
      {
        labelKey: "communications.pages.commandes",
        key: "commandes_factures_commandes",
        checked: messagePages.includes("commandes_factures_commandes"),
        subPages: [
          {
            labelKey: "communications.pages.vos-commandes",
            key: "commandes_factures_commandes",
            checked: messagePages.includes("commandes_factures_commandes"),
          },
          {
            labelKey: "communications.pages.details-commande",
            key: "commandes_factures_commandes-item",
            checked: messagePages.includes("commandes_factures_commandes-item"),
          },
        ],
      },
    ],
  ];
}

export { buildPages, Page, SubPage };
